/**
 * Theme Header Presenter
 */
 class ThemeHeaderPresenter {

	constructor(sectionId, queryProductsMax, queryPagesMax, queryCollectionsMax) {

		this.view = new ThemeHeaderView(this, sectionId);
		this.queryProductsMax = queryProductsMax;
		this.queryPagesMax = queryPagesMax;
		this.queryCollectionsMax = queryCollectionsMax;
		this.queryWaiting = null;
		this.queryActivity = 0;
		
		/*
		 * Listeners
		 */

		$(document).on(Model.LOCAL_STORAGE_AVAILABLE, $.proxy(function(_event) {
			this.view.setLocalStorageAvailable();
		}, this));

		$(document).on(Model.CART_RETRIEVED, $.proxy(function(_event, cart) {
			// update the cart count
			this.view.setCartCount(cart.items.length);
		}, this));

		$(document).on(Model.CART_ITEM_QUANTITY_UPDATED, $.proxy(function(_event, cart, _delta) {
			// update the cart count
			this.view.setCartCount(cart.items.length);
		}, this));

	}

	/*
	 * Actions
	 */

	retrieveQuery(route, query) {

		// check to see if there is query activity, and if there is set this query as the latest query waiting to be actioned
		if (this.queryActivity > 0) { 
			this.queryWaiting = { route: route, query: query };
			return;
		}

		// setup the parameters for the call to retrieve the search query
		const type = "product,page,collection";
		const limit = 25;
		const callback = $.proxy(function(data, callbackQuery) {
			
			this.decrementQueryActivity();
			if (this.queryWaiting != null) { return; }
			this.view.clearQueryResults();
			
			var products = data.resources.results.products;
			if (products === undefined || Array.isArray(products) == false) { products = new Array(); }
			if (products.length > this.queryProductsMax) { products = products.slice(0, this.queryProductsMax); }
			for (const product of products) { this.retrieveRenderedProduct(product); }
			
			var pages = data.resources.results.pages;
			if (pages === undefined || Array.isArray(pages) == false) { pages = new Array(); }
			if (pages.length > this.queryPagesMax) { pages = pages.slice(0, this.queryPagesMax); }
			this.view.setQueryPages(pages);
			
			var collections = data.resources.results.collections;
			if (collections === undefined || Array.isArray(collections) == false) { collections = new Array(); }
			if (collections.length > this.queryPagesMax) { collections = collections.slice(0, this.queryPagesMax); }
			this.view.setQueryCollections(collections);
			
			this.view.showSearchOffcanvasBody(true);
			this.view.setSearchLink("/search?q=" + encodeURIComponent(callbackQuery) + "&type=product"); 

		}, this);
		const errorCallback = $.proxy(function() {
			// something has gone wrong, so decrement the activity
			this.decrementQueryActivity();
		}, this);

		// request the search query is retrieved, and increment the query activity
		$(document).trigger(Model.RETRIEVE_SEARCH_QUERY, [route, query, type, limit, callback, errorCallback]);
		this.incrementQueryActivity();

	}

	retrieveRenderedProduct(product) {

		// make sure this product has a handle
		if (product.handle === undefined) { return; }

		// setup the parameters for the call to render this product's thumbnail section
		const url = "/products/" + product.handle + "?section_id=product-thumbnail-section";
		const callback = $.proxy(function(html) {
			// we have retrieved the product thumbnail, so set it in the view and decrement the activity
			const product = $(html).find("div").first();
			this.view.addQueryProduct(product);
			this.decrementQueryActivity();
		}, this);
		const errorCallback = $.proxy(function() {
			// something has gone wrong, so decrement the activity
			this.decrementQueryActivity();
		}, this);

		// request that is product's thumbnail section is rendered, and increment the query activity
		$(document).trigger(Model.RETRIEVE_RENDERED_SECTION, [ url, callback, errorCallback ]);
		this.incrementQueryActivity();

	}

	incrementQueryActivity() {
		
		// increment the query activity count
		this.queryActivity++;

	}

	decrementQueryActivity() {
		
		// decrement the query activity count, making sure it never gets less then zero
		if (this.queryActivity < 0) { this.queryActivity = 0; }
		this.queryActivity--;
		
		// if there is no query activity, check if there is a query waiting to be retrieved
		if (this.queryActivity == 0 && this.queryWaiting != null) {
			// there is, so get its parameters and reset the waiting field
			const route = this.queryWaiting.route;
			const query = this.queryWaiting.query;
			this.queryWaiting = null;
			// retrieve the query
			this.retrieveQuery(route, query);
		}

	}

	lastHeightChanged(lastHeight) {
		// notify listeners that the header last height value has changed
		$(document).trigger(Model.HEADER_LAST_HEIGHT_CHANGED, [lastHeight]);
	}

}